import axios from  'axios'

const api = {

  async post ( path, data ) {
    try {
      return await axios.post(
        this.adminApi(path), data)
        .then( response => response )
    } catch (e) {
      console.log(e)
      return e.status
    }
  },

  async get (path, adminHeaders) {
    try {
      return await axios.get( 
          this.adminApi(path),
          this.publicOptions(adminHeaders)
        )
        .then( (response) => {
          return response 
        })
    } catch {
      return false
    }
  },

  async postAdmin ( path, data, adminHeaders ) {
    try {
      return await axios.post( 
        this.adminApi(path), 
        data, 
        this.adminOptions(adminHeaders)
        )
        .then( response => response )
    } catch (e) {
      return e
    }
  },

  async putAdmin ( path, data, adminHeaders ) {
    try {
      return await axios.put( 
        this.adminApi(path), 
        data, 
        this.adminOptions(adminHeaders)
        )
        .then( response => response )
    } catch (e) {
      return e
    }
  },

  async deleteAdminById ( path, adminHeaders ) {
    try {
      return await axios.delete( 
        this.adminApi(path), 
        this.adminOptions(adminHeaders)
        )
        .then( response => response )
    } catch (e) {
      return e
    }
  },

  async getAdmin (path, adminHeaders) {
    try {
      return await axios.get( 
        this.adminApi(path), 
        this.adminOptions(adminHeaders)
        )
        .then( response => response )
    } catch (e) {
      return e
    }
  },

  adminApi ( path ) {
    let baseurl =  process.env.VUE_APP_API
    if ( !baseurl.endsWith('/') ) {
      baseurl += '/'
    }
    //baseurl += 'admin/'
    let p = path
    if ( p.startsWith('/') ) {
      p = path.slice(1)
    }
    return `${baseurl}${p}`
  },

  adminOptions ( additionalHeaders ) {
    const token = localStorage.getItem('axs')
    const defaultHeaders = {  
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
    return {
      headers: Object.assign(
        {},
        defaultHeaders.headers,
        ( additionalHeaders ? additionalHeaders.headers: {} 
      ))
    }
  },

  publicApi ( path ) {
    let baseurl =  process.env.VUE_APP_API
    if ( !baseurl.endsWith('/') ) {
      baseurl += '/'
    }
    //baseurl += 'admin/'
    let p = path
    if ( p.startsWith('/') ) {
      p = path.slice(1)
    }
    return `${baseurl}${p}`
  },

  publicOptions ( additionalHeaders ) {
    const token = localStorage.getItem('uid')
    
    if(token) {
      const defaultHeaders = {  
        headers: {
          ukey: `${token}`
        }
      }
      return {
        headers: Object.assign(
          {},
          defaultHeaders.headers,
          ( additionalHeaders ? additionalHeaders.headers: {} 
        ))
      }
    } else {
      return {
        headers: Object.assign(
          {},
          {},
          ( additionalHeaders ? additionalHeaders.headers: {} 
        ))
      }
    }
  }
  
}

export default api